// utils/typeGuards.ts
import { ErrorResponse } from '@/types/ErrorResponse'; // Assurez-vous que le chemin est correct

export function isErrorResponse(response: any): response is ErrorResponse {
    return response && typeof response === 'object' && 'status' in response && 'message' in response;
}
